import { render, staticRenderFns } from "./SlackDropdown.vue?vue&type=template&id=5f0b6c21"
import script from "./SlackDropdown.vue?vue&type=script&lang=js"
export * from "./SlackDropdown.vue?vue&type=script&lang=js"
import style0 from "./SlackDropdown.vue?vue&type=style&index=0&id=5f0b6c21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports